import { api } from "@/api";
import { QueryProps } from "@/types/Api";
import { BettingMarketValues } from "@/types/ApiResponses/BettingMarket";

export interface GetBettingMarketsParams {
  category?: string;
  // Sport scope by category ("football" | "basketball"). Omitted → all markets.
  sportCategory?: string;
  lang?: string;
}

export const getBettingMarkets = async (
  props: QueryProps<GetBettingMarketsParams>
): Promise<BettingMarketValues[]> => {
  const res = await api.client.get(`/betting-markets-new`, {
    signal: props.signal,
    params: props.params,
  });
  return res.data;
};
